import React, { useState, useEffect } from 'react';
import { Chip, Stack } from '@mui/material';
import {
  Autocomplete,
  TextField,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Paper,
  CircularProgress,
  Card,
} from '@mui/material';
import { postRequest } from '../../../lib/api'; // adjust path as needed
import { AuthContext } from '../../../authContext/context';
import { useContext } from 'react';
import toast from 'react-hot-toast';
import { useParams , useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import BreadcrumbsWrapper from '../../../components/breadcrumbs' 
import Button from '@mui/material/Button';

export default function ViewIndividualAdminUsers() {
  const authCtx = useContext(AuthContext);
  const {id} = useParams()
  const navigate = useNavigate()

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adminName, setAdminName] = useState();
  const [groupTitle, setGroupTitle] = useState('');
  const [groupPermissions, setGroupPermissions] = useState({
    leads: {
      create: false,
      view: false,
      edit: false,
      delete: false,
      revise_quotes: false,
      change_group_code: false
    },
    customers: {
      create: false,
      view_details: false,
      edit: false,
      delete: false
    },
    notes: {
      view: false,
      create: false,
      edit: false
    },
    settings: {
      manage_users: false,
      manage_user_groups: false,
      manage_user_group_permissions: false,
      manage_partners: false,
      manage_solicitors: false,
      manage_branches: false,
      manage_group_codes: false,
      manage_email_templates: false,
      configure_automation: false,
      manage_sms_templates: false,
      manage_lender_panels: false,
      configure_task_definition: false,
      manage_lead_sub_statuses: false,
      configure_tags: false,
      manage_custom_lead_fees: false
    },
    api: {
      create_api_keys: false,
      disable_api_keys: false
    }
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

const handleSelect = async (event, value) => {
  if (value && !selectedUsers.find((u) => u.username === value.username)) {
    try {
      const res = await postRequest(`private/addUserinGroup/${id}`, { userId: value._id });
      if (res?.status === 200) {
        toast.success('User added to group successfully');
        setSelectedUsers((prev) => [...prev, value]);
      } else {
        toast.error(res?.message || 'Failed to add user');
      }
    } catch (err) {
      toast.error(err?.message || 'Failed to add user');
    }
  }
};


const fetchUsersInGroup = async () => {
  try {
    const res = await postRequest(`private/getUsersInGroup/${id}`, {});
      console.log(res , 'Response----')
            setAdminName(res?.groupName)
    if (res?.status === 200 && Array.isArray(res.data)) {
      setSelectedUsers(res.data); 
    } else {
      toast.error(res?.message || 'Failed to fetch group users');
    }
  } catch (err) {
    toast.error('Error fetching group users');
  }
  
  // Also fetch the group details including permissions
  try {
    const groupRes = await postRequest(`private/singleUserGroup/${id}`, {});
    console.log('Group details response:', groupRes);
    if (groupRes?.status === 200 && groupRes?.data) {
      if (groupRes.data.permissions) {
        console.log('Setting permissions from backend:', groupRes.data.permissions);
        setGroupPermissions(groupRes.data.permissions);
      }
      if (groupRes.data.title) {
        setGroupTitle(groupRes.data.title);
        console.log('Set group title to:', groupRes.data.title);
      }
    }
  } catch (err) {
    console.error('Error fetching group permissions:', err);
  }
};

const handlePermissionChange = (category, permission) => {
  setGroupPermissions(prev => {
    const newPermissions = {
      ...prev,
      [category]: {
        ...prev[category],
        [permission]: !prev[category][permission]
      }
    };
    
    // If enabling create leads, automatically enable customer view details
    if (category === 'leads' && permission === 'create' && !prev[category][permission]) {
      newPermissions.customers = {
        ...newPermissions.customers,
        view_details: true
      };
    }
    
    // If disabling customer view details, check if create leads is enabled
    if (category === 'customers' && permission === 'view_details' && prev[category][permission]) {
      if (newPermissions.leads.create) {
        // Don't allow disabling customer view if create leads is enabled
        alert('Cannot disable Customer View Details while Create Leads is enabled');
        return prev;
      }
    }
    
    setHasUnsavedChanges(true);
    return newPermissions;
  });
};

const handleSavePermissions = async () => {
  try {
    const payload = {
      title: groupTitle || adminName || 'Group', // Use existing title
      permissions: groupPermissions
    };
    
    console.log('Saving permissions with payload:', payload);
    console.log('Group ID:', id);
    
    const response = await postRequest(`private/editUserGroup/${id}`, payload);
    
    if (response?.status === 200) {
      toast.success('Permissions updated successfully');
      setHasUnsavedChanges(false);
    } else {
      console.error('Failed to update permissions:', response);
      toast.error(response?.message || 'Failed to update permissions');
    }
  } catch (err) {
    console.error('Error updating permissions:', err);
    toast.error(err?.message || 'Error updating permissions');
  }
};


const handleRemoveUser = async (username) => {
  const userToRemove = selectedUsers.find((u) => u.username === username);
  if (!userToRemove) return;

  try {
    const res = await postRequest(`private/deleteUserinGroup/${id}`, { userId: userToRemove._id });
    if (res?.status === 200) {
      toast.success('User removed from group successfully');
      setSelectedUsers((prev) => prev.filter((u) => u.username !== username));
    } else {
      toast.error(res?.message || 'Failed to remove user');
    }
  } catch (err) {
    toast.error(err?.message || 'Failed to remove user');
  }
};



  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const res = await postRequest('private/fetchUserListForAdmin', {});
      
        if (res?.status === 200 && Array.isArray(res.data)) {
          setUserOptions(res.data); 
      
        } else {
          toast.error(res?.message || 'Failed to fetch users');
        }
      } catch (err) {
        toast.error('Failed to fetch users');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
     fetchUsersInGroup(); 
  }, [authCtx.token]);

  const handleDelete = async (userId) => {
  if (selectedUsers.length > 0) {
    Swal.fire({
      title: 'Cannot delete group',
      text: 'Please remove all users from the group before deleting.',
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
    });
    return;
  }

  const confirm = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you really want to delete this user group?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
  });

  if (confirm.isConfirmed) {
    try {
      const response = await postRequest(`private/deleteUserGroup/${userId}`, {});
      if (response?.status === 200 || response?.success) {
        Swal.fire('Deleted!', 'User group has been deleted.', 'success');
        setSelectedUsers([]);
        navigate('/user-groups'); // Optional: Navigate after delete
      } else {
        Swal.fire('Error', response?.message || 'Failed to delete user group', 'error');
      }
    } catch (err) {
      Swal.fire('Error', err?.message || 'Failed to delete user group', 'error');
    }
  }
};


  return (

    
    <Box sx={{ width: '100%', mx: 'auto'}}>
       <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>{adminName}</h1>
        <div>
              {/* <MUIButton
                variant="contained"
                color="error"
                size="small"
                style={{ marginRight: 8 }}
                onClick={() => handleDelete(id)}
               // onClick={() => navigate(`/partners/edit/${id}`)}
              >
                Delete
              </MUIButton> */}

          <Button variant="contained" type="submit" className='red-bg red-button text-capitalize ' style={{ marginRight: 8 }}
                onClick={() => handleDelete(id)}>Delete</Button>
              {/* <MUIButton
                variant="outlined"
                className='red-outline-btn text-capitalize'
                size="small"
                  onClick={() => navigate(`/user-groups/edit/${id}`)}
              >
                Edit
              </MUIButton> */}
              <Button variant="outlined" className='red-outline-btn text-capitalize'  onClick={() => navigate(`/user-groups/edit/${id}`)}>
                           Edit
                          </Button>
            </div>
       
      </div>

     <BreadcrumbsWrapper
                              items={[
                                { label: 'Dashboard', path: '/dashboard' },
                                { label: 'User Groups', path: '/user-groups' },
                                { label: 'User Groups View', path: '' },
                              ]}
                            />
                      <br></br>

  
      <Autocomplete
        options={userOptions}
        getOptionLabel={(option) => `${option.forename} ${option.surname} (${option.username})`}
        onChange={handleSelect}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Username"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        filterSelectedOptions
      />

      <Box sx={{ display: 'flex', gap: 3, mt: 3 }}>
        {/* Left: Selected Users */}
        <Paper elevation={3} sx={{ flex: 1, p: 2, maxHeight: '400px', overflow: 'auto' }}>
          <Typography variant="h6" gutterBottom sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
            Selected Users
          </Typography>
          {selectedUsers.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No users selected
            </Typography>
          )}
          <Stack spacing={1}>
            {selectedUsers.map((user) => (
              <Chip
                key={user.username}
                label={`${user.forename} ${user.surname} (${user.username})`}
                onDelete={() => handleRemoveUser(user.username)}
                sx={{
                  height: '28px',
                  fontSize: '0.85rem',
                  '& .MuiChip-deleteIcon': {
                    fontSize: '18px',
                  },
                }}
                variant="outlined"
              />
            ))}
          </Stack>
        </Paper>

        {/* Right: Permissions */}
        <Paper elevation={3} sx={{ flex: 1, p: 2, maxHeight: '600px', overflow: 'auto' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">
              Permissions
            </Typography>
            {hasUnsavedChanges && (
              <Button
                variant="contained"
                size="small"
                className='red-bg red-button text-capitalize'
                onClick={handleSavePermissions}
              >
                Save Permissions
              </Button>
            )}
          </Box>
          <FormGroup>
            {/* Lead Permissions */}
            <Typography variant="subtitle2" sx={{ mt: 1, mb: 1, fontWeight: 600 }}>
              Leads
            </Typography>
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.leads.create} onChange={() => handlePermissionChange('leads', 'create')} />}
              label="Create Leads"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.leads.view} onChange={() => handlePermissionChange('leads', 'view')} />}
              label="View Leads"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.leads.edit} onChange={() => handlePermissionChange('leads', 'edit')} />}
              label="Edit Leads"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.leads.delete} onChange={() => handlePermissionChange('leads', 'delete')} />}
              label="Delete Leads"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.leads.revise_quotes} onChange={() => handlePermissionChange('leads', 'revise_quotes')} />}
              label="Revise Quotes"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.leads.change_group_code} onChange={() => handlePermissionChange('leads', 'change_group_code')} />}
              label="Change Group Code"
            />
            
            {/* Customer Permissions */}
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
              Customers
            </Typography>
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.customers.create} onChange={() => handlePermissionChange('customers', 'create')} />}
              label="Create Customer"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.customers.view_details} onChange={() => handlePermissionChange('customers', 'view_details')} />}
              label="View Customer Details"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.customers.edit} onChange={() => handlePermissionChange('customers', 'edit')} />}
              label="Edit Customer"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.customers.delete} onChange={() => handlePermissionChange('customers', 'delete')} />}
              label="Delete Customers"
            />
            
            {/* Notes Permissions */}
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
              Notes
            </Typography>
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.notes.view} onChange={() => handlePermissionChange('notes', 'view')} />}
              label="View Notes"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.notes.create} onChange={() => handlePermissionChange('notes', 'create')} />}
              label="Create Notes"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.notes.edit} onChange={() => handlePermissionChange('notes', 'edit')} />}
              label="Edit Notes"
            />
            
            {/* Settings Permissions */}
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
              Settings
            </Typography>
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_users} onChange={() => handlePermissionChange('settings', 'manage_users')} />}
              label="Manage Users"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_user_groups} onChange={() => handlePermissionChange('settings', 'manage_user_groups')} />}
              label="Manage User Groups"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_user_group_permissions} onChange={() => handlePermissionChange('settings', 'manage_user_group_permissions')} />}
              label="Manage User Group Permissions"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_partners} onChange={() => handlePermissionChange('settings', 'manage_partners')} />}
              label="Manage Partners"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_solicitors} onChange={() => handlePermissionChange('settings', 'manage_solicitors')} />}
              label="Manage Solicitors"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_branches} onChange={() => handlePermissionChange('settings', 'manage_branches')} />}
              label="Manage Branches"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_group_codes} onChange={() => handlePermissionChange('settings', 'manage_group_codes')} />}
              label="Manage Group Codes"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_email_templates} onChange={() => handlePermissionChange('settings', 'manage_email_templates')} />}
              label="Manage Email Templates"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.configure_automation} onChange={() => handlePermissionChange('settings', 'configure_automation')} />}
              label="Configure Automation"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_sms_templates} onChange={() => handlePermissionChange('settings', 'manage_sms_templates')} />}
              label="Manage SMS Templates"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_lender_panels} onChange={() => handlePermissionChange('settings', 'manage_lender_panels')} />}
              label="Manage Lender Panels"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.configure_task_definition} onChange={() => handlePermissionChange('settings', 'configure_task_definition')} />}
              label="Configure Task Definition"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_lead_sub_statuses} onChange={() => handlePermissionChange('settings', 'manage_lead_sub_statuses')} />}
              label="Manage Lead Sub-Statuses"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.configure_tags} onChange={() => handlePermissionChange('settings', 'configure_tags')} />}
              label="Configure Tags"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.settings.manage_custom_lead_fees} onChange={() => handlePermissionChange('settings', 'manage_custom_lead_fees')} />}
              label="Manage Custom Lead Fees"
            />
            
            {/* API Permissions */}
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
              API
            </Typography>
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.api.create_api_keys} onChange={() => handlePermissionChange('api', 'create_api_keys')} />}
              label="Create API Keys"
            />
            <FormControlLabel
              control={<Checkbox checked={groupPermissions.api.disable_api_keys} onChange={() => handlePermissionChange('api', 'disable_api_keys')} />}
              label="Disable API Keys"
            />
          </FormGroup>
        </Paper>
      </Box>
    </Box>
  );
}
